import {
  IProductListFilterItem,
  ProductListFilterItemBoolean,
  ProductListFilterItemRange,
  ProductListFilterItemType,
  ProductListFilterItemValueType,
} from "../../../../typescript-library";

export const convertToFilterTypes = (
  filtersToConvert: {
    [k: string]: string;
  },
  filterItems: Map<string, IProductListFilterItem>,
): {[k: string]: ProductListFilterItemValueType} => {
  const filters: {[k: string]: ProductListFilterItemValueType} = {};

  Object.keys(filtersToConvert).forEach((key) => {
    const filterItem = filterItems.get(key);
    if (filterItem) {
      const value = filtersToConvert[key];
      switch (filterItem.type) {
        case ProductListFilterItemType.select:
          filters[key] = value.split(",");
          break;
        case ProductListFilterItemType.range:
          if (value.indexOf("-") > -1) {
            const [min, max] = value.split("-");
            filters[key] = {
              min: min ? parseInt(min, 10) : (filterItem as ProductListFilterItemRange).min,
              max: max ? parseInt(max, 10) : (filterItem as ProductListFilterItemRange).max,
            };
          }
          break;
        case ProductListFilterItemType.boolean:
          if (value === ProductListFilterItemBoolean.trueValueId) {
            filters[key] = true;
          }
          break;
      }
    }
  });

  return filters;
};
